// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space-card-badges[data-v-5d300e98]{position:relative}.space-card-badges .space-card-badge[data-v-5d300e98]{position:absolute;width:2rem;text-align:center;font-size:2rem;color:var(--q4s-white);z-index:2;top:10px}", ""]);
// Exports
module.exports = exports;
